import { render, staticRenderFns } from "./TemplateSummary.vue?vue&type=template&id=663868a5"
import script from "./TemplateSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateSummary.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports